import { useState } from 'react';
import { Content } from 'components/Page';
import {
  ApprovalGroupsTable,
  BusinessUnitSearchBar,
  editApprovalGroupMutationKey,
} from 'ApprovalGroupsPage/components';
import { BusinessUnit } from 'Dictionary/model/BusinessUnit';
import { useMyProfileQuery } from 'MyProfile/query/myProfile.query';
import { useIsMutating } from 'react-query';

export const ApprovalGroupsPage = () => {
  const [businessUnit, setBusinessUnit] = useState<BusinessUnit | null>(null);
  const mutating = useIsMutating({ mutationKey: editApprovalGroupMutationKey });
  const { data: userData } = useMyProfileQuery();
    const isAdmin = userData?.isAdmin;
    const allowedDivisionCodes = !userData?.isAdmin && userData?.roles
      ? userData?.roles
        .filter(r => r.type === 'LocalAdministrator')
        .flatMap(r => r.details?.map(d => d.description1))
        .filter(Boolean)
      : [];
  return (
    <Content
      title="Approval groups"
      subtitle="Here you can add new or manage existing approval groups."
      mutating={Boolean(mutating)}
    >
      <BusinessUnitSearchBar onBuChange={setBusinessUnit} allowedDivisionCodes={allowedDivisionCodes} isAdmin={isAdmin}/>
      <ApprovalGroupsTable businessUnit={businessUnit} />
    </Content>
  );
};
